import { useState } from "react"

import { useTranslation } from "@/hooks/useTranslation"
import { getCloudConnectionStep } from "@/pages/DeploymentsPage/components/molecules/CloudConnectionStatus"
import {
  AgentPlatformTab,
  CLOUD_CONNECTION_METHOD,
  useSensorMethods
} from "@/pages/DeploymentsPage/components/organisms/AgentPlatformTab"
import { FoundryDemoConnect } from "./FoundryDemoConnect"
import { FoundryDemoGrant } from "./FoundryDemoGrant"
import { getFoundryPlatform } from "./helpers"

import type { AgentPlatformMethod } from "@/pages/DeploymentsPage/components/organisms/AgentPlatformTab"
import type { FoundryTabProps } from "./FoundryTab.types"

export const FoundryTab = ({
  demoCloudConnection,
  ...props
}: FoundryTabProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "deployments" })
  const platform = getFoundryPlatform(props.version)
  const sensorMethods = useSensorMethods(platform, props)
  const [subscriptionId, setSubscriptionId] = useState("")
  // Shown in the demo only: Foundry has no cloud connection yet
  const cloudMethods: AgentPlatformMethod[] = demoCloudConnection
    ? [
        {
          key: CLOUD_CONNECTION_METHOD,
          label: t("agentPlatform.deployment.cloudConnection"),
          render: () => [
            getCloudConnectionStep(
              t("foundry.cloud.steps.grantPrefix"),
              t("foundry.cloud.steps.grant"),
              <FoundryDemoGrant subscriptionId={subscriptionId} />
            ),
            getCloudConnectionStep(
              t("foundry.cloud.steps.connectPrefix"),
              t("foundry.cloud.steps.connect"),
              <FoundryDemoConnect
                subscriptionId={subscriptionId}
                onSubscriptionIdChange={setSubscriptionId}
              />
            )
          ]
        }
      ]
    : []

  return (
    <AgentPlatformTab
      platform={platform}
      methods={[...cloudMethods, ...sensorMethods]}
      defaultMethod={cloudMethods[0]?.key}
    />
  )
}
